export default {
  "hospitals": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hospitals"])},
  "projects": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Projects"])},
  "devices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devices"])},
  "assets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assets"])},
  "tests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tests"])},
  "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["About"])}
}